import React, { useReducer } from "react";

export const initialState = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  phoneNumber: "",
  websiteAddress: "",
  memberNumber: "",
  terms: false,
};

const reducerFn = (state, action) => {
  switch (action.type) {
    case "onChangeGeneric":
      action.preventDefault();
      return {
        ...state,
        [action.value.name]: action.value.value,
      };
    case "onChangeCheckbox":
      return {
        ...state,
        [action.value.name]: action.value.checked,
        tosErrorText: action.error,
      };
    case "onFileChange":
      if (state[action.key]) {
        return {
          ...state,
          [action.key]: [{ ...state[action.key][0] }, { ...action.value }],
          error: action.error,
        };
      }
      return {
        ...state,
        [action.key]: [{ ...action.value }],
        error: action.error,
      };
    case "onFileChangeCancel":
      return {
        ...state,
        [action.key]: null,
        error: action.error,
      };
    case "onJobLoad":
      return {
        ...state,
        jobId: action.value,
      };
    default:
      return state;
  }
};

const withFormState = (Component) => (props) => {
  const [formState, dispatch] = useReducer(reducerFn, initialState);

  return <Component {...props} formState={formState} dispatch={dispatch} />;
};

export default withFormState;
